import { AlertTriangle, HelpCircle } from "lucide-react";
import type { LandscapeRunStatus } from "@/types";
import { runStatusLabel } from "@/utils/landscapeRunStatus";
import { STATUS_ICON, STATUS_TEXT_CLASS } from "./constants";

interface StatusIndicatorProps {
  status: LandscapeRunStatus | string | null;
}

/**
 * Total, not partial (`components/work-run-log.md § The screen`, "Status
 * rendering must be total"): an unrecognised status falls back to
 * `HelpCircle` / `text-muted-foreground` rather than throwing on an
 * `undefined` `Record` lookup, and its label comes from `runStatusLabel`
 * rather than a second lookup of its own.
 */
export function StatusIndicator({ status }: StatusIndicatorProps) {
  const known = status !== null && status in STATUS_ICON;
  const Icon = known ? STATUS_ICON[status as LandscapeRunStatus] : HelpCircle;
  const textClass = known ? STATUS_TEXT_CLASS[status as LandscapeRunStatus] : "text-muted-foreground";
  const label = runStatusLabel(status);

  return (
    <div className="flex items-center gap-1.5">
      <Icon className={`h-4 w-4 ${textClass} ${status === "running" ? "animate-spin" : ""}`} strokeWidth={2} />
      <span className={`text-xs ${textClass}`}>{label}</span>
    </div>
  );
}

export function RetryIndicator({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span className="inline-flex items-center gap-0.5 text-amber-600 text-xs ml-2">
      <AlertTriangle className="h-3 w-3" />
      {count}
    </span>
  );
}
